<button
  type="button"
  class="inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700"
  (click)="openPicker()">
  <app-svg-icon src="assets/icons/variable.svg" [size]="14" />
  {{ label() }}
</button>
